import * as types from './mutation-types'

export default {
    [types.SET_RECORDS](state, records) {
        state.records = records
    },
    [types.SET_RECORD_TYPES](state, recordTypes) {
        state.recordTypes = recordTypes
    },
    [types.SET_RESPONSIBLE_TYPES](state, responsibleTypes) {
        state.responsibleTypes = responsibleTypes
    },
    [types.SET_ESTABLISHMENTS](state, establishments) {
        state.establishments = establishments
    },
    [types.SET_STATS](state, stats) {
        state.stats = stats
    },
    [types.SET_SELECTED_RECORD](state, record) {
        state.selectedRecord = record
    },
    [types.SET_LOADING](state, loading) {
        state.loading = loading
    },
    [types.SET_ERROR](state, error) {
        state.error = error
    },
}
